/**
 * Template panel, uses kendo template to generate view
 * receives data.template and data.model to generate html
 */
(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbTemplatePanel', lbTemplatePanelDirective);

    function lbTemplatePanelDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                // panel does not need scope.model and scope.content
                panel: "=",
                model: "=",
                content: '='
            },
            controller: lbTemplatePanelDirectiveCtrl
        };
    }

    function lbTemplatePanelDirectiveCtrl($scope, $element, $compile, lodash, $sce) {
        this.$onInit = function() {
            var template = lodash.get($scope, 'panel.data.template', '');
            var data = lodash.get($scope, 'panel.data.model', {});
            $scope.data = angular.copy(data);
            $element.html(template);
            $compile($element.contents())($scope);

            $scope.getOption = function (name) {
                return lodash.get($scope.panel, 'data.options.' + name, {});
            };

            $scope.trust = (type, value) => {
                return $sce.trustAs($sce[type], value);
            };
        }
    }
})();